<template>
  <v-container>
    <v-form
      v-if="type === 'PORTAL_REQUEST' && qtaMax > 0"
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <v-card outlined>
        <v-card-title>
          <v-icon
            slot="icon"
            color="primary"
            size="36"
          >mdi-bank</v-icon>
          <h4 class="primary--text">{{ $t("company") }}</h4>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col
              md="6"
              cols="12"
            >
              <v-text-field
                v-model="asdInfo.ragSoc"
                :label="$t('ragSoc')"
                :rules="required"
                hide-details="auto"
              ></v-text-field>
            </v-col>
            <v-col
              md="3"
              cols="12"
            >
              <v-text-field
                v-model="asdInfo.respLegaleName"
                :label="$t('resp_legal_name')"
                :rules="required"
                hide-details="auto"
              ></v-text-field><v-text-field
                v-model="asdInfo.respLegaleSurname"
                :label="$t('resp_legal_surname')"
                :rules="required"
                hide-details="auto"
              ></v-text-field><v-text-field
                v-model="asdInfo.respLegaleCFisc"
                :label="$t('resp_legal_cfisc')"
                :rules="required"
                hide-details="auto"
              ></v-text-field>
            </v-col>

            <v-col
              md="3"
              cols="12"
            >
              <my-datepicker
                v-model="asdInfo.dateCostituzione"
                :label="$t('date_foundation')"
                :required="true"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col
              md="6"
              cols="12"
            >
              <v-text-field
                v-model="asdInfo.nome"
                :rules="required"
                :label="$t('name')"
                hide-details="auto"
              ></v-text-field>
            </v-col>
            <v-col
              md="3"
              cols="12"
            >
              <v-text-field
                v-model="asdInfo.cFiscale"
                :rules="required"
                :label="$t('fiscal_code')"
                hide-details="auto"
              ></v-text-field>
            </v-col>
            <v-col
              md="3"
              cols="12"
            >
              <v-text-field
                v-model="asdInfo.pIva"
                :label="$t('pIva')"
                hide-details="auto"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              md="2"
              cols="4"
            >
              <v-checkbox
                :false-value="0"
                :true-value="1"
                v-model="asdInfo.ifMonosportiva"
                :label="$t('monosport')"
              ></v-checkbox>
            </v-col>
            <v-col
              md="2"
              cols="4"
            >
              <v-checkbox
                :false-value="0"
                :true-value="1"
                v-model="asdInfo.ifBAS"
                :label="$t('BAS_society')"
              ></v-checkbox>
            </v-col>
            <v-col
              md="2"
              cols="4"
            >
              <v-checkbox
                :false-value="0"
                :true-value="1"
                v-model="asdInfo.ifRegAPS"
                :label="$t('if_reg_APS')"
              ></v-checkbox>
            </v-col>
            <v-col
              md="3"
              cols="12"
            >
              <v-select
                v-model="asdInfo.meseInizioEsercizio"
                :items="listMesi"
                item-text="dex"
                item-value="key"
                :label="$t('month_start_exercise')"
                hide-details="auto"
              ></v-select>
            </v-col>
            <v-col
              md="3"
              cols="12"
            >
              <v-select
                v-model="asdInfo.naturaGiuridica"
                :label="$t('legal_nature')"
                :rules="required"
                :items="natureGiuridiche"
                item-text="Name"
                item-value="Code"
                hide-details="auto"
              ></v-select>
            </v-col>

          </v-row>
          <v-row>
            <v-col
              md="4"
              cols="12"
            >
              <v-text-field
                v-model="asdInfo.webSite"
                :label="$t('website')"
                hide-details="auto"
              ></v-text-field>
            </v-col>
            <v-col
              md="4"
              cols="12"
            >
              <v-text-field
                v-model="asdInfo.email"
                :label="$t('email')"
                hide-details="auto"
              ></v-text-field>
            </v-col>
            <v-col
              md="4"
              cols="12"
            >
              <v-text-field
                v-model="asdInfo.pec"
                :label="$t('pec')"
                hide-details="auto"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

    </v-form>
    <v-form
      v-else-if="type === 'CREDITS' && modeCredits === 'range'"
      ref="form"
      v-model="valid"
      lazy-validation
    > <v-row>
 <v-col
          cols="12"
        >
          <v-card>
            <v-card-text>
            <v-row>
              <v-col
                cols="12"
              >
                <v-slider
                  v-model="selectedCredits"
                  :min="Number(minCredits)"
                  :max="Number(maxCredits)"
                  :step="Number(stepCredits)"
                  thumb-label="always"
                  :label="$t('credits')"
                  style="margin-top: 15px"
                ></v-slider>
              </v-col>
            </v-row>
            </v-card-text>
          </v-card>
        </v-col>
</v-row>
  </v-form>
    <v-form
      v-else-if="qtaMax > 0"
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <v-row>
        <v-col
          v-if="type !== 'CREDITS' && qtaMax > 1"
          cols="12"
        >
          <v-container>
            <v-slider
              v-model="qta"
              @end="setQta"
              min="1"
              thumb-label="always"
              :max="qtaMax"
              :label="$t('quantity')"
              style="margin-top: 15px"
            >
              <template v-slot:prepend>
                <v-icon
                  color="primary"
                  @click="decrement"
                >mdi-minus</v-icon>
              </template>

              <template v-slot:append>
                <v-icon
                  color="primary"
                  @click="increment"
                >mdi-plus</v-icon>
              </template>
            </v-slider>
          </v-container>
        </v-col>
        <v-col cols="12">
          <v-divider></v-divider>
        </v-col>
      </v-row>
      <v-row
        v-if="element === 1"
        align="center"
        justify="center"
      >
        <v-col
          :md="12 / element"
          cols="12"
        >
          <v-layout
            row
            wrap
            justify-center
          >
            <img
              class="product-image"
              :src="image"
            />
          </v-layout>
        </v-col>
      </v-row>
      <v-row
        v-else-if="element > 1"
        v-for="configureProduct in configuredProducts"
        :key="configureProduct.id"
        align="center"
        justify="center"
      >
        <v-col
          :md="12 / element"
          cols="12"
        >
          <v-layout
            row
            wrap
            justify-center
          >
            <img
              class="product-image"
              :src="image"
            />
          </v-layout>
        </v-col>
        <v-col
          :md="12 / element"
          v-if="options && options.length > 0"
          cols="12"
        >
          <base-material-card
            color="secondary"
            :title="$t('configure_product')"
          >
            <v-row
              v-for="option in options"
              v-bind:key="option.id"
            >
              <v-container>
                <v-radio-group
                  :label="option.id"
                  :mandatory="true"
                  row
                  v-model="configureProduct['options'][option.id]"
                >
                  <v-radio
                    v-for="value in option.values"
                    v-bind:key="value"
                    :label="value"
                    :value="value"
                  ></v-radio>
                </v-radio-group>
              </v-container>
            </v-row>
          </base-material-card>
        </v-col>
        <v-col
          :md="12 / element"
          cols="12"
          v-if="metadata && metadata.length > 0"
        >
          <base-material-card
            color="secondary"
            :title="$t('insert_data')"
          >
            <v-row
              v-for="field in metadata"
              v-bind:key="field.key"
            >
              <v-container>
                <v-text-field
                  v-model="configureProduct['metadata'][field.key]"
                  :label="$t(field.key)"
                  :rules="
                    field.required ? [(value) => !!value || 'Required.'] : true
                  "
                  hide-details="auto"
                ></v-text-field>
              </v-container>
            </v-row>
          </base-material-card>
        </v-col>
        <v-col cols="12">
          <v-divider></v-divider>
        </v-col>
      </v-row>
    </v-form>
    <v-row
      class="justify-center"
      v-if="viewPrice && qtaMax > 0"
    >
      <v-col
        md="2"
        cols="12"
        class="text-center"
      >
        <base-material-card
          color="secondary"
          icon="mdi-cash"
          :title="$t('total')"
          class="text-right"
        >
          <h1>{{ type === 'CREDITS' ? selectedCredits : prezzo * qta }}</h1>
        </base-material-card>
      </v-col>
    </v-row>
    <v-row v-if="qtaMax <= 0"  ><v-col cols="12" class="text-center">
    PRODOTTO ESAURITO
    </v-col></v-row>
    <v-row class="justify-center">
      <v-col
        cols="12"
        class="text-center"
      >
        <v-btn
          class="v-btn--flat"
          @click="confirmProduct"
          :disabled="qtaMax <= 0"
          color="success"
        >{{
          $t("confirm_choise")
        }}</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import MyDatepicker from "@/components/base/MyDatepicker.vue";

export default {
  name: "product-configuration",
  components: {
    MyDatepicker,
  },
  props: {
    setQtaMax: {
      type: Number,
      default: null,
    },
    viewPrice: {
      type: Boolean,
      default: true,
    },
    idProduct: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      element: 1,
      qta: null,
      qtaMax: null,
      image: null,
      productCode: null,
      title: null,
      options: null,
      metadata: null,
      prezzo: null,
      type: null,
      minCredits: null,
      maxCredits: null,
      modeCredits: null,
      buyWithCredits: null,
      stepCredits: 1,
      selectedCredits: null,
      valid: null,
      asdInfo: {},
      natureGiuridiche: [],
      configuredProducts: [],
      listMesi: [
        { key: 1, dex: this.$t("january") },
        { key: 2, dex: this.$t("february") },
        { key: 3, dex: this.$t("march") },
        { key: 4, dex: this.$t("april") },
        { key: 5, dex: this.$t("may") },
        { key: 6, dex: this.$t("june") },
        { key: 7, dex: this.$t("july") },
        { key: 8, dex: this.$t("august") },
        { key: 9, dex: this.$t("september") },
        { key: 10, dex: this.$t("october") },
        { key: 11, dex: this.$t("november") },
        { key: 12, dex: this.$t("december") },
      ],
      required: [(value) => !!value || this.$t("required_field")],
    };
  },

  methods: {
    setQta() {
      for (let x = 0; x < this.qta; x++) {
        if (!this.configuredProducts[x]) {
          this.configuredProducts[x] = {
            options: {},
            metadata: {},
            id: x,
          };
        }
      }
      this.configuredProducts = this.configuredProducts.slice(0, this.qta);
    },
    decrement() {
      this.qta--;
      if (this.qta < 0) this.qta = 0;
      this.setQta();
    },
    increment() {
      this.qta++;
      if (this.qta > this.qtaMax) this.qta = this.qtaMax;
      this.setQta();
    },
    loadData() {
      let _ = this;
      this.qta = 1;
      this.setQta();
      this.element = 1;
      _.natureGiuridiche = window.systemData.natureGiuridiche;
      if (_.idProduct) {
        let url = "/auth/prodotti/getProduct/" + _.idProduct;
        _.chiamataAxios("GET", url).then((response) => {
          _.image = response.data.image;
          _.type = response.data.type;
          _.productCode = response.data.productCode;
          _.buyWithCredits = response.data.buyWithCredits;
          _.title = response.data.title;
          _.options = response.data.options;
          _.metadata = response.data.metadata;
          _.prezzo = response.data.prezzo;
          _.qtaMax = response.data.qta;
          _.minCredits = response.data.minCredits;
          _.maxCredits = response.data.maxCredits;
          _.modeCredits = response.data.modeCredits;
          _.stepCredits = response.data.stepCredits && response.data.stepCredits > 0 ? response.data.stepCredits : 1;
          _.selectedCredits = _.modeCredits === "single"
            ? Number(_.maxCredits)
            : Number(_.minCredits);
          if (_.type === "CREDITS") {
            _.qta = 1;
            _.setQta();
          }
          if (_.options.length > 0) _.element++;
          if (_.metadata.length > 0) _.element++;
          if (_.setQtaMax && _.qtaMax > _.setQtaMax) _.qtaMax = _.setQtaMax;
          if (_.element > 1 && _.qtaMax > 10) _.qtaMax = 10;
        });
      }
    },
    confirmProduct() {
      let esito = this.$refs.form.validate();
      if (esito) {
        const finalPrice =
          this.type === "CREDITS"
            ? Number(this.selectedCredits || this.maxCredits || 0)
            : this.prezzo;

        const configuration =
          this.type === "CREDITS"
            ? [
                {
                  options: {},
                  metadata: { credits: finalPrice },
                  id: 0,
                },
              ]
            : this.type === "PORTAL_REQUEST"
            ? [{ options: null, metadata: this.asdInfo, id: 1 }]
            : this.configuredProducts;

        this.$emit("configured", {
          type: this.type,
          productCode: this.productCode,
          buyWithCredits: this.buyWithCredits,
          prezzo: finalPrice,
          // descr: this.descr.replace(/<[^>]*>?/gm, ""),
          title: this.title,
          selectedConfiguration: configuration, 
        });
      }
    },
  },

  computed: {
    ifSingleCredits: function () {
      return Number(this.maxCredits) === Number(this.minCredits);
    },
  },

  mounted() {
    this.loadData();
  },
  watch: {
    idProduct: function (newVal, oldVal) {
      // watch it
      if (newVal) this.loadData();
    },
  },
};
</script>
<style>
.product-image {
  max-width: 400px;
  max-height: 400px;
}
</style>